import React from 'react';
import { Gift, MapPin, Sparkles, LayoutGrid, Home } from 'lucide-react';
const bonuses = [{
  num: '01',
  icon: MapPin,
  title: 'Guía de Terrenos',
  subtitle: 'Cómo Elegir el Terreno Correcto Antes de Construir',
  desc: 'Los 8 puntos que hay que verificar antes de comprar. Orientación solar, pendiente y servicios — lo que nadie te cuenta.',
  value: '$8.900'
}, {
  num: '02',
  icon: Sparkles,
  title: 'Guía de Terminaciones',
  subtitle: 'Las Terminaciones que Más Valor Agregan al Menor Costo',
  desc: 'Las 10 terminaciones con mayor ROI en el mercado argentino. Qué hace que una casa "se vea cara" sin serlo.',
  value: '$9.900'
}, {
  num: '03',
  icon: LayoutGrid,
  title: 'El Layout Perfecto',
  subtitle: 'Distribuí los Muebles Antes de Construir la Primera Pared',
  desc: 'Los 5 principios de distribución. Medidas mínimas de cada espacio. Grilla imprimible 1:50. Checklist de 20 puntos.',
  value: '$9.900'
}, {
  num: '04',
  icon: Home,
  title: '30 Casas Modernas Argentina',
  subtitle: 'Fachadas + Renders + Distribuciones: Elegí tu Estilo en 15 Minutos',
  desc: '30 diseños modernos argentinos con render fotorrealista + ilustración técnica + distribución amueblada por cada uno.',
  value: '$12.900'
}];
export function BonusSection() {
  return <section id="bonos" className="py-20 bg-white" data-id="element-21">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 text-gold mb-6" data-id="element-24">
            <Gift className="w-8 h-8" data-id="element-25" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 text-charcoal" data-id="element-26">
            4 Bonos Estratégicos
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-27">
            Siempre incluidos en los dos packs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-28">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          return <div key={i} className="bg-beige rounded-xl p-8 border border-beige-dark relative overflow-hidden group hover:border-gold hover:shadow-md transition-all shadow-sm" data-id="element-29">
                <div className="flex items-start gap-5" data-id="element-30">
                  <div className="shrink-0 relative" data-id="element-31">
                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-gold to-gold-light flex items-center justify-center shadow-md group-hover:scale-105 transition-transform" data-id="element-32">
                      <Icon className="w-8 h-8 text-white" strokeWidth={2} data-id="element-33" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-charcoal text-white flex items-center justify-center font-bold text-xs shadow-md border-2 border-beige" data-id="element-34">
                      {bonus.num}
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-35">
                    <h3 className="font-bold text-xl text-charcoal mb-2" data-id="element-36">
                      {bonus.title}
                    </h3>
                    <p className="text-base font-semibold text-gold mb-3" data-id="element-37">
                      {bonus.subtitle}
                    </p>
                    <p className="text-base text-gray-600 mb-5 leading-relaxed" data-id="element-38">
                      {bonus.desc}
                    </p>
                    <div className="flex items-center gap-3 text-lg pt-3 border-t border-beige-dark/60" data-id="element-39">
                      <span className="text-red-500 line-through font-medium" data-id="element-40">
                        {bonus.value}
                      </span>
                      <span className="font-bold text-gold text-xl" data-id="element-41">
                        GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {/* Prominent total price block */}
        <div className="mt-16 relative" data-id="element-42">
          <div className="absolute inset-0 bg-gradient-to-br from-gold/20 to-terracotta/10 rounded-2xl blur-2xl" data-id="element-43"></div>
          <div className="relative bg-charcoal text-white rounded-2xl border-2 border-gold shadow-2xl overflow-hidden" data-id="element-44">
            <div className="absolute top-0 right-0 bg-gold text-charcoal text-xs font-bold px-4 py-1.5 rounded-bl-xl uppercase tracking-wider" data-id="element-45">
              Bonos incluidos
            </div>
            <div className="px-6 py-10 md:px-12 md:py-12 text-center" data-id="element-46">
              <p className="text-sm md:text-base text-gold font-semibold uppercase tracking-widest mb-3" data-id="element-47">
                Valor total de los 4 bonos
              </p>
              <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 mb-4" data-id="element-48">
                <span className="text-3xl md:text-4xl text-red-400 line-through font-medium" data-id="element-49">
                  $41.600
                </span>
                <span className="hidden md:inline text-gold text-3xl" data-id="element-50">→</span>
                <span className="text-5xl md:text-7xl font-serif font-bold text-gold" data-id="element-51">
                  GRATIS
                </span>
              </div>
              <p className="text-base md:text-lg text-gray-300 mt-4 max-w-xl mx-auto" data-id="element-52">
                Hoy se suman sin costo a cualquiera de los dos packs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}